(function ( $ ) {
     $.fn.menuLink = function (options) {
         var settings = $.extend({
            someOption: ""
        }, options);

        var objLink    = $(this);
        var dropdown   = $('.dropdown');
        var head       = $('#head');
        var nav        = $('#head .nav');
        var opened     = false;

        var didScroll;
        var lastScrollTop = 0;
        var delta = 200;

        function _init() {
            $( objLink ).click(function() {
                if($('#head .nav').hasClass('close')){
                    $(this).addClass('open');
                    _openNavigation();
                }else{
                    $(this).removeClass('open');
                    _closeNavigation();
                }
            });
            _initScroll();

            $(".nav a[href='#rezervace']").click(function( event ){
                event.preventDefault();
                $('#modal').addClass('active');
            });
        }

        function hasScrolled() {
            scroll = 100;
            if($(this).scrollTop() > scroll){
                $('body').addClass('hasFixedHead');
            }else{
                $('body').removeClass('hasFixedHead');
            }
        }

        function _initScroll(){
            $(window).scroll(function(event){
                  didScroll = true;
            });

            setInterval(function() {
                 if (didScroll) {
                     hasScrolled();
                     didScroll = false;
                 }
             }, 1000);
        }

        function _closeNavigation(){
            $(nav).addClass('close');
            $(objLink).find('i').addClass('icon-menu').removeClass('icon-close');
            $('body').removeClass('locked');
        }

        function _openNavigation(){

            $(nav).addClass('active').removeClass('close');
            $(objLink).find('i').removeClass('icon-menu').addClass('icon-close');
            $('body').addClass('locked');
        }

        _init();

       return {
         reload:_init,
       };
    };
}( jQuery ));

$("#head a.mobilNav").menuLink();
